import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Carousel } from '../components/Carousel';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import async from 'async';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { CommonStyles } from '../styles/Styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { relativesettings } from '../components/SliderSettings'
import { Categories } from '../components/Categories';
import { EmptyMsgView } from '../components/EmptyMsgView';
import { AppConfig } from '../AppConfig';
import { ReasonsComponent } from '../components/ReasonsComponent';
import { BannerComponent } from '../components/BannerComponent';
import { HelmetComponent } from '../common/components/HelmetComponent';

export class Home extends Component {

  constructor(props) {
    super(props)
    this.prodOrderByList = {}
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      prodFetchState: ApiHelper.State.LOADING,
      homeList: {},
      homeTopList: {},
      autoplay: 0,
      showVideo: false,
    }
  }

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems() {
    const options = {
      method: 'GET',
      authWithKey: true,
      endPoint: ApiHelper.makeUrlPath(['miscs', 'homeelements'])
    };
    ApiHelper.call(options, (err, results) => {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err) //TODO: entire page will be errored out since majority of date is painted from backend
        })
        return
      }
      this.processResponse(results)
    });
  }

  processResponse(results) {
    let banner = null
    let partnersList = null
    let nums = null
    let news = null
    let productIds = []
    const productListBySlug = {}
    if (results) {
      banner = results.banners //TODO: we are taking the first banner
      partnersList = results.partners
      nums = results.nums
      news = results.news
      if (results.prodlists) {
        for (const pList of results.prodlists) {
          if (!pList.items || !pList.slug) {
            continue
          }

          productListBySlug[pList.slug] = {}
          productListBySlug[pList.slug].title = pList.title
          productListBySlug[pList.slug].descr = pList.descr
          productListBySlug[pList.slug].slug = pList.slug
          productListBySlug[pList.slug].placement = pList.placement
          productListBySlug[pList.slug].items = pList.items
          productListBySlug[pList.slug].productIds = []
          this.prodOrderByList[pList.slug] = {}
          for (const p in pList.items) {
            if (!pList.items[p].prodId) {
              continue
            }
            this.prodOrderByList[pList.slug][pList.items[p].prodId] =  pList.items[p].order
            productListBySlug[pList.slug].productIds.push(pList.items[p].prodId)
            productIds.push(pList.items[p].prodId)
          }
        }
      }
    }

    productIds = Helper.removeDuplicates(productIds)

    this.setState({
      banner: banner,
      partnersList: partnersList,
      healthCounts: nums,
      news: news,
      productListBySlug: productListBySlug,
      fetchState: ApiHelper.State.READY
    }, () => this.getSubHomeElelements(productIds))
  }

  getSubHomeElelements(activeProdIds) {
    async.parallel(
      [
        function (callback) {
          ApiHelper.call(
            { method: 'GET', authWithKey: true, endPoint: ApiHelper.makeUrlPath(['miscs', 'cats']) },
            callback)
        },
        function (callback) {
          ApiHelper.call(
            {
              method: 'GET', authWithKey: true, endPoint: ApiHelper.makeUrlPath(['miscs', 'products'],
                { prodIds: activeProdIds })
            }, callback)
        },
      ],
      function (err, results) {
        if (err) {
          this.setState({
            prodFetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        const productListByPlacement = this.getProductByPlacement(results[1])

        this.setState({
          mainCategories: results[0].items,
          productListByPlacement: productListByPlacement,
          homeList: this.getHomeListItems(productListByPlacement),
          homeTopList: this.getHomeTopListItems(productListByPlacement),
          prodFetchState: ApiHelper.State.READY
        })
      }.bind(this))
  }

  getHomeListItems = (productListByPlacement) => {
    for (const key in productListByPlacement) {
      if (key !== 'HOME') {
        continue
      }
      if (productListByPlacement[key] && productListByPlacement[key].length > 0) {
        return productListByPlacement[key][0]
      }
    }
    return {}
  }

  getHomeTopListItems = (productListByPlacement) => {
    for (const key in productListByPlacement) {
      if (key !== 'HOMETOP') {
        continue
      }
      if (productListByPlacement[key] && productListByPlacement[key].length > 0) {
        return productListByPlacement[key][0]
      }
    }
    return {}
  }

  getProductByPlacement = (result) => {
    const productsByListSlug = {}

    if (result && result.items) {
      for (const r of result.items) {
        for (const key in this.state.productListBySlug) {
          if (this.state.productListBySlug[key].productIds.includes(r.id)) {
            const pItem = {
              id: r.id,
              images: r.images,
              order: this.prodOrderByList[key][r.id],
              slug: r.slug,
              title: r.title
            }
            if (productsByListSlug[key]) {
              productsByListSlug[key].items.push(pItem)
            } else {
              productsByListSlug[key] = {}
              productsByListSlug[key].items = [pItem]
              productsByListSlug[key].title = this.state.productListBySlug[key].title
              productsByListSlug[key].descr = this.state.productListBySlug[key].descr
              productsByListSlug[key].slug = this.state.productListBySlug[key].slug
              productsByListSlug[key].placement = this.state.productListBySlug[key].placement
            }
          }
        }
      }
    }

    const productListByPlacement = {}
    for (const key in productsByListSlug) {
      if (!productsByListSlug[key].placement) {
        continue
      }
      if (productListByPlacement[productsByListSlug[key].placement]) {
        productListByPlacement[productsByListSlug[key].placement].push(productsByListSlug[key])
      } else {
        productListByPlacement[productsByListSlug[key].placement] = [productsByListSlug[key]]
      }
    }

    return productListByPlacement
  }

  getNewsTile() {
    return (
      this.state.news.length > 0 &&
      this.state.news.map((item, index) => {
        return (
          <div
            key={index}
            className={css(CommonStyles.subContainer)}>
            {this.getKnowMoreTile(item)}
          </div>
        )
      })
    )
  }

  getKnowMoreTile(item) {
    return (
      <a href={item.link} target='_blank' className={css(CommonStyles.link)}>
        <div style={{ backgroundImage: `url(${require('../assets/images/new-tile-bg.jpg')}` }} //TODO: In design each news tile had different bg
          className={css(CommonStyles.knowMoreTile)}>
          <div className={css(CommonStyles.knowMoresubContainer)}>
            <h4 className={css(CommonStyles.knowMoreTileText)}>
              {item.title}
            </h4>

            <p
              className={css([CommonStyles.knowMoreTileText, CommonStyles.knowMoreTileTextSpec])}>
              Know more<i className={'material-icons ' + css(CommonStyles.knowMoreIcon)}>
                keyboard_arrow_right
              </i>
            </p>
          </div>
        </div>
      </a>
    )
  }

  getHomeTopList() {
    if (this.state.prodFetchState === ApiHelper.State.LOADING) {
      return (
        <div className={css(CommonStyles.productsSlider)}>
          <CircularProgress size={40} className={css(CommonStyles.progress)} />
        </div>
      )
    } else {
      if (!this.state.homeTopList || !this.state.homeTopList.items || this.state.homeTopList.items.length < 3) {
        return
      }

      return (
        <div className={css(CommonStyles.productsSlider)}>
          <h2
            className={css(CommonStyles.sliderTitleVariant)} >
            {this.state.homeTopList.title}
          </h2>
          <p className={css(CommonStyles.descrText)} >
            {this.state.homeTopList.descr}
          </p>
          {this.state.homeTopList &&
            <Carousel
              data={this.state.homeTopList.items}
              settings={relativesettings} />
          }
          <Link
            to={'/groups/' + this.state.homeTopList.slug}
            className={css(CommonStyles.link)}>
            <p
              className={css(CommonStyles.viewAllDeals, CommonStyles.viewAllDealsCust)}>
              View all<i className={'material-icons ' + css(CommonStyles.viewAllIcon, CommonStyles.viewAllIconCust)}>
                keyboard_arrow_right
              </i>
            </p>
          </Link>
        </div>
      )
    }
  }

  getHomeList() {
    if (this.state.prodFetchState === ApiHelper.State.LOADING) {
      return (
        <div className={css(CommonStyles.equipmentSlider)}>
          <CircularProgress size={40} className={css(CommonStyles.progress)} />
        </div>
      )
    } else {
      if (!this.state.homeList || !this.state.homeList.items || this.state.homeList.items.length < 3) {
        return
      }

      return (
        <div className={css(CommonStyles.equipmentSlider)}>
          <h2
            className={css(CommonStyles.sliderTitle)} >
            {this.state.homeList.title}
          </h2>
          <p className={css([CommonStyles.descrText, CommonStyles.descrTextSpec])} >
            {this.state.homeList.descr}
          </p>
          {this.state.homeList && this.state.homeList.items && this.state.homeList.items.length >= 3 &&
            <Carousel
              equipment={true}
              data={this.state.homeList.items}
              settings={relativesettings} />
          }
          <Link
            to={'/groups/' + this.state.homeList.slug}
            className={css(CommonStyles.link)}>
            <p
              className={css(CommonStyles.viewAllDeals)}>
              View all<i className={'material-icons ' + css(CommonStyles.viewAllIcon)}>
                keyboard_arrow_right
              </i>
            </p>
          </Link>
        </div>
      )
    }
  }

  getPartnersList() {
    return (
      <div className={css(CommonStyles.mainContainer)}>
        <h2 className={css(CommonStyles.subTitle)}>
          Our Partners
        </h2>
        <div className={css(CommonStyles.partnersSubContainer)}>
          {this.state.partnersList.length > 0 &&
            this.state.partnersList.map((item, index) => {
              if(!item.slug) {
                return (
                  <div
                    key={index}
                    className={css(CommonStyles.partnersLogoContainer)}>
                    <img
                      className={css(CommonStyles.partnersLogo)}
                      src={item.image} />
                  </div>
                )
              } else {
                return (
                  <Link
                    to={'/brands/' + item.slug}
                    className={css(CommonStyles.link)}>
                    <div
                      key={index}
                      className={css(CommonStyles.partnersLogoContainer)}>
                      <img
                        className={css(CommonStyles.partnersLogo)}
                        src={item.image} />
                    </div>
                  </Link>
                )
              }
            })}
        </div>
      </div>
    )
  }

  handlePlay = () => {
    this.setState({ autoplay: 1, showVideo: true })
  }

  getVideoTile() {
    const videoSrc = 'https://www.youtube.com/embed/M7uApvPzpXo' + '?autoplay=' +
      this.state.autoplay;
    return (
      <div className={css(CommonStyles.videoContainer)}>
        <h1 className={css(CommonStyles.videoTitle)}>
          Choose {AppConfig.NAME} to evaluate the best procurement
          option for your healthcare facility.
        </h1>
        <div className={css(CommonStyles.demoVideo)}>
          {this.state.showVideo &&
            <iframe
              allow='autoplay'
              allowFullScreen='true'
              className={css(CommonStyles.videoContainerTile)}
              type='text/html'
              width='100%'
              height='100%'
              src={videoSrc}
              frameborder='0' />
          }
          {!this.state.showVideo &&
            <div
              className={css(CommonStyles.videoContainerTile)}
              style={{ backgroundImage: `url(${require('../assets/images/video-bg-2.jpg')}` }}>
              <img
                onClick={() => this.handlePlay()} src={require('../assets/images/play-button.svg')}
                className={css(CommonStyles.playButton)} />
            </div>
          }
        </div>
      </div>
    )
  }

  getHealthCounts() {
    return (
      <div className={css(CommonStyles.overView)}>
        <h2 className={css(CommonStyles.subTitle, CommonStyles.marginTop)}>
          {AppConfig.NAME} in numbers
        </h2>
        <div className={css(CommonStyles.healthCountContainer)}>
          {this.state.healthCounts.length > 0 &&
            this.state.healthCounts.map((item, index) => {
              return (
                <div
                  key={index}
                  className={css(CommonStyles.healthCountSubContainer)}>

                  <p className={css(CommonStyles.countNumber)}>
                    {item.title}
                  </p>
                  <p className={css(CommonStyles.countTitle)}>
                    {item.subTitle}
                  </p>
                </div>
              )
            })}
        </div>
      </div>
    )
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return <EmptyMsgView msg={this.state.errMsg} />
    } else {
      return this.readyView();
    }
  }


  readyView() {
    return (
      <div className={css(CommonStyles.container)}>
        
        <HelmetComponent page={'home'}/>
        
        <div className={css(CommonStyles.leftContainer)}>
          <Categories />

          {window.innerWidth > 767 &&
            this.getNewsTile()
          }
        </div>

        <div className={css(CommonStyles.rightContainer)}>
          {this.getHomeTopList()}

          {this.state.banner &&
            <BannerComponent
              data={this.state.banner}
            />
          }

          {this.getHomeList()}
          {window.innerWidth < 768 &&
            <div className={css(CommonStyles.newsContainer)}>
              {this.getNewsTile()}
            </div>
          }
          {this.getPartnersList()}
          <ReasonsComponent />
          {this.getVideoTile()}
          {this.getHealthCounts()}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/Home.js